import { createContext } from "react"

const TemplatesManagerContext = createContext()

export default TemplatesManagerContext
